import { gql } from '@generated/gql';

const cashbackCalculatorRetailersQuery = gql(`
  query CashbackCalculatorRetailers {
  cashbackCalculatorRetailers {
      partners {
        id
        name
        logoUrl
        discount
        category
        avgMonthlySpend
      }
      nonPartners {
        id
        name
        logoUrl
        discount
        category
        avgMonthlySpend
      }
    }
  }
`);

const saveCalculatorDataMutation = gql(`
mutation SaveCashbackCalculatorDetails($basketId: ID!, $details: CashbackCalculatorDetailsInput!) {
  saveCashbackCalculatorDetails(basketId: $basketId, details: $details)
}
`);

export { cashbackCalculatorRetailersQuery, saveCalculatorDataMutation };
